import { createFileRoute } from "@tanstack/react-router";
import Utilaje from "@/pages/Utilaje";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/utilaje/")({
  head: () => routeHead("/utilaje/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Utilaje />
  );
}
